export const ROW_ACTIONS = {
  OPEN_RECORD: "open-record",
  EDIT_RECORD: "edit-record",
  DELETE_RECORD: "delete-record",
  SELECT_RECORD: "select-record",
  DOWNLOAD_RECORD: "download-record",
  PLAY_RECORD: "play-record",
  TRANSCRIBE: "transcribe",
  VIEW_TRANSCRIPT: "view-transcript",
  COPY: "copy",
  OPEN_DOWNLOAD_CONTENT: "open-download-content",
  EDIT_SESSION: "edit-session",
  OPEN_SYNC_LOG_MODAL: "open-sync-log-modal",
  ASSIGN_TASK: "assign-task",
  REMOVE_ASSIGNMENT_TASK: "remove-assignment-task",
  OPEN_EMAIL_CAMPAIGN_MODAL: "open-email-campaign-modal", // in case we need to listen this action from the outside and do something with it
  OPEN_EMAIL_RECIPIENTS_MODAL: "open-email-recipients-modal"
};

export const DARK_COLORS_MAP = {
  "#343434": true,
  "#1e62d8": true,
  "#1b6ec2": true,
  "#2f9e44": true,
  "#e03131": true,
  "#e8590c": true,
  "#f08c00": true
};

export const CONTACT_TYPE_FIELD_NAMES = [
  "Speakers",
  "Moderator",
  "Chairperson"
];
